<app-navbar title="Definicje - Tagi Leadów">
	<button class="btn btn-primary me-2" (click)="addAsk()">Dodaj</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="modal fade" id="askModalDelete" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Czy na pewno usunąć?</h5>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="deleteClose()">
					Nie
				</button>
				<button type="button" class="btn btn-primary" (click)="deleteConfirm()">Tak</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="askModalAdd" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Dodaj tag</h5>
			</div>
			<div class="modal-body">
				<div class="alert alert-danger" role="alert" *ngIf="addError">{{ addError }}</div>
				<form class="my-4" (submit)="addConfirm()">
					<div class="mb-3 row">
						<label class="col-sm-3 col-form-label" for="tagAddGroup">Grupa</label>
						<input
							class="form-control col-sm-9"
							name="tagAddGroup"
							[(ngModel)]="tagAdd.group"
							id="tagAddGroup"
							required
						/>
					</div>
					<div class="mb-3 row">
						<label class="col-sm-3 col-form-label" for="tagAdd">Tag</label>
						<input
							class="form-control col-sm-9"
							name="tagAdd"
							[(ngModel)]="tagAdd.id"
							id="tagAdd"
							required
						/>
					</div>
				</form>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="addConfirm()">Zapisz</button>
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="addClose()">
					Anuluj
				</button>
			</div>
		</div>
	</div>
</div>

<table class="table table-striped table-hover">
	<thead>
		<tr>
			<th scope="col">Group</th>
			<th scope="col">Tag</th>
			<th scope="col"></th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of tags">
			<th scope="row">{{ item.groupName }}</th>
			<td>{{ item.tag }}</td>
			<td><button type="button" class="btn btn-info" (click)="deleteAsk(item.tag)">Usuń</button></td>
		</tr>
	</tbody>
</table>
